export interface PaymentResult {
  success: boolean;
  transactionId?: string;
  errorMessage?: string;
  amount?: number;
  paymentMethod?: string;
}

export const TransactionState = {
  CANCEL_FROM_TERMINAL: 'cancel_from_terminal',
  CANCELED: 'transaction_canceled',
  CANCELLED_FROM_POS: 'transaction_canceled_pos',
  CANCEL_FROM_POS_UNREFERENCED_REFUND: 'cancel_from_pos_unreferenced_refund',
  CANCEL_UNAVAILABLE: 'transaction_cancellation_failed',
  NON_CANCELLABLE_STATE: 'transaction_cancellation_not_possible',
  COMPLETE: 'transaction_complete',
  DECLINED: 'transaction_declined',
  ERROR: 'error',
  FAILED: 'transaction_failed',
  IN_PROGRESS: 'in_progress',
  TERMINAL_ERROR: 'terminal_error',
  SERVICE_EXCEPTION: 'service_exception',
  WAITING_TO_START: 'waiting_to_start',
  CONNECTION_DEGRADED: 'connection_degraded',
  CONNECTION_KO: 'connection_ko',
};

export const STRINGS = {
  CONNECTIVITY: {
    [TransactionState.CONNECTION_DEGRADED]: {
      title: `We're having trouble connecting with the server`,
      message: `Please wait a few seconds while we try to reconnect`,
    },
    [TransactionState.CONNECTION_KO]: {
      title: `Connectivity issue`,
      message: `We are currently unable to re-establish a connection.\nBefore retrying the transaction, check your terminal to verify if the payment was processed.`,
    },
  },
};
